webpackJsonp([7],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unmountGoalPanel = exports.renderGoalPanel = undefined;
	
	__webpack_require__(120);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(22);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _GoalPanel = __webpack_require__(675);
	
	var _GoalPanel2 = _interopRequireDefault(_GoalPanel);
	
	var _Messages = __webpack_require__(119);
	
	var _Messages2 = _interopRequireDefault(_Messages);
	
	var _MessageDefinitions = __webpack_require__(244);
	
	var _MessageDefinitions2 = _interopRequireDefault(_MessageDefinitions);
	
	var _Locale = __webpack_require__(118);
	
	var _reactIntl = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function render(nodeId) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      goalTypesKey = _ref.goalTypesKey,
	      goalTypes = _ref.goalTypes,
	      qualifier = _ref.qualifier,
	      toggle = _ref.toggle,
	      _ref$initialGoals = _ref.initialGoals,
	      initialGoals = _ref$initialGoals === undefined ? [] : _ref$initialGoals,
	      _ref$messages = _ref.messages,
	      customMessages = _ref$messages === undefined ? {} : _ref$messages;
	
	  var mountNode = document.getElementById(nodeId);
	  var messages = _Messages2.default.get(_MessageDefinitions2.default, customMessages);
	
	  var goals = initialGoals.length ? initialGoals : [{}];
	
	  window.ignite.getAnswerService().then(function (answerService) {
	    _reactDom2.default.render(_react2.default.createElement(
	      _reactIntl.IntlProvider,
	      { locale: (0, _Locale.getLocale)(), messages: messages },
	      _react2.default.createElement(_GoalPanel2.default, {
	        goalTypesKey: goalTypesKey,
	        goalTypes: goalTypes,
	        qualifier: qualifier,
	        toggle: toggle,
	        initialGoals: goals,
	        answerService: answerService
	      })
	    ), mountNode);
	  });
	}
	
	function renderGoalPanel(goalPanelId, params) {
	  render(goalPanelId, params);
	}
	
	function unmountGoalPanel(goalPanelId) {
	  _reactDom2.default.unmountComponentAtNode(document.getElementById(goalPanelId));
	}
	
	if (window.ignite) {
	  window.ignite.renderGoalPanel = renderGoalPanel;
	
	  window.ignite.unmountGoalPanel = unmountGoalPanel;
	}
	
	exports.renderGoalPanel = renderGoalPanel;
	exports.unmountGoalPanel = unmountGoalPanel;

/***/ },

/***/ 244:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * (c) 2015 Ignite Sales, Inc.
	 * User: aholmes
	 * Date: 6/8/2016
	 * Time: 9:58 AM
	 */
	exports.default = {
	  addGoal: {
	    id: 'goal.addGoal',
	    description: 'Message for adding a goal',
	    defaultMessage: 'New Goal'
	  },
	  goalPrompt: {
	    id: 'goal.prompt',
	    description: 'The default message prompt for selecting your goal.',
	    defaultMessage: 'What is your goal?'
	  },
	  timingDefault: {
	    id: 'goal.timing',
	    description: 'The default message prompt for the timing cell.',
	    defaultMessage: 'When will you need the money?'
	  },
	  amountDefault: {
	    id: 'goal.amount',
	    description: 'The default message prompt for the amount cell.',
	    defaultMessage: 'How much will you need?'
	  },
	  validationRequired: {
	    id: 'goal.validation.required',
	    description: 'The default required validation message',
	    defaultMessage: 'Please provide an answer.'
	  },
	  validationBetween: {
	    id: 'goal.validation.between',
	    description: 'The min/max required validation message',
	    defaultMessage: 'Amount must be between {min} and {max}'
	  },
	  validationMinimum: {
	    id: 'goal.validation.minimum',
	    description: 'The minimum required validation message',
	    defaultMessage: 'Amount must be more than {min}'
	  }
	};
	module.exports = exports['default'];

/***/ },

/***/ 675:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(54);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _set = __webpack_require__(377);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _toConsumableArray2 = __webpack_require__(183);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(27);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(15);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(16);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(29);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(28);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class, _temp2;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GoalRow = __webpack_require__(676);
	
	var _MessageDefinitions = __webpack_require__(244);
	
	var _MessageDefinitions2 = _interopRequireDefault(_MessageDefinitions);
	
	var _reactIntl = __webpack_require__(10);
	
	var _reactFontawesome = __webpack_require__(31);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _classnames = __webpack_require__(38);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(214);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GoalPanel = (_temp2 = _class = function (_React$Component) {
	  (0, _inherits3.default)(GoalPanel, _React$Component);
	
	  function GoalPanel() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, GoalPanel);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = GoalPanel.__proto__ || (0, _getPrototypeOf2.default)(GoalPanel)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      goals: _this.props.initialGoals || [{}]
	    }, _this.addGoal = function () {
	      _this.setState({
	        goals: [].concat((0, _toConsumableArray3.default)(_this.state.goals), [{}])
	      });
	    }, _this.updateGoalTypes = function (goals) {
	      var goalTypes = goals.filter(function (g) {
	        return g.goalType;
	      }).map(function (g) {
	        return g.goalType.key;
	      });
	      var goalTypesKey = _this.props.goalTypesKey;
	
	
	      _this.props.answerService.saveAnswer({
	        appkey: goalTypesKey,
	        value: goalTypes,
	        timestamp: new Date()
	      });
	    }, _this.removeValues = function (goalType) {
	      var qualifier = _this.props.qualifier;
	
	      _this.props.answerService.removeAnswer('' + goalType.key + qualifier);
	      _this.props.answerService.removeAnswer(goalType.key + 'Timing');
	    }, _this.validateGoalAmount = function (goalType, amount) {
	      return goalType.max ? amount >= goalType.min && amount <= goalType.max : amount >= goalType.min;
	    }, _this.setValues = (0, _lodash2.default)(function (_ref2) {
	      var goalType = _ref2.goalType,
	          amount = _ref2.amount,
	          timing = _ref2.timing;
	      var qualifier = _this.props.qualifier;
	
	
	      if (amount === '' || amount === undefined || !_this.validateGoalAmount(goalType, amount)) {
	        _this.props.answerService.removeAnswer('' + goalType.key + qualifier);
	      } else {
	        _this.props.answerService.saveAnswer({
	          appkey: '' + goalType.key + qualifier,
	          value: amount,
	          timestamp: new Date()
	        });
	      }
	
	      if (!timing) {
	        _this.props.answerService.removeAnswer(goalType.key + 'Timing');
	      } else {
	        _this.props.answerService.saveAnswer({
	          appkey: goalType.key + 'Timing',
	          value: timing,
	          timestamp: new Date()
	        });
	      }
	    }, 500), _this.removeGoal = function (index) {
	      var goals = _this.state.goals;
	      var goalToRemove = goals[index];
	
	      goals.splice(index, 1);
	      _this.updateGoalTypes(goals);
	      _this.removeValues({
	        goalType: goalToRemove.goalType
	      });
	      var finalGoals = goals.length ? [].concat((0, _toConsumableArray3.default)(goals)) : [{}];
	      _this.setState({
	        goals: [].concat((0, _toConsumableArray3.default)(finalGoals))
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(GoalPanel, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          goalTypes = _props.goalTypes,
	          toggle = _props.toggle;
	      var goals = this.state.goals;
	
	
	      var selectedGoalTypes = new _set2.default(goals.filter(function (t) {
	        return t.goalType;
	      }).map(function (t) {
	        return t.goalType.key;
	      }));
	
	      var allowedGoalTypes = goalTypes.filter(function (_ref3) {
	        var key = _ref3.key;
	
	        if (key === toggle) {
	          return selectedGoalTypes.size === 0;
	        } else {
	          return !selectedGoalTypes.has(key);
	        }
	      });
	
	      var renderedGoals = goals.map(function (goal, index) {
	        var goalChanged = function goalChanged(e, _ref4) {
	          var amount = _ref4.amount,
	              timing = _ref4.timing;
	
	          goal.amount = amount;
	          goal.timing = timing;
	          _this2.setState({
	            goals: [].concat((0, _toConsumableArray3.default)(goals))
	          });
	          _this2.setValues({
	            goalType: goal.goalType,
	            amount: amount,
	            timing: timing
	          });
	        };
	        var goalTypeChanged = function goalTypeChanged(value) {
	          goal.goalType = goalTypes.find(function (g) {
	            return g.key === value;
	          });
	          if (value === toggle) {
	            var newGoals = [goal];
	            goalTypes.filter(function (g) {
	              return g.key !== toggle;
	            }).forEach(_this2.removeValues);
	            _this2.updateGoalTypes(newGoals);
	            _this2.setState({
	              goals: newGoals
	            });
	          } else {
	            var _newGoals = [].concat((0, _toConsumableArray3.default)(goals));
	            _this2.updateGoalTypes(_newGoals);
	            _this2.setState({
	              goals: _newGoals
	            });
	          }
	        };
	        var goalRemoved = function goalRemoved() {
	          _this2.removeGoal(index);
	        };
	        var goalType = goal.goalType;
	
	        return goalType ? _react2.default.createElement(_GoalRow.SelectedGoalRow, (0, _extends3.default)({}, goal, {
	          key: index,
	          onChange: goalChanged,
	          onRemove: goalRemoved,
	          isToggle: goalType.key === toggle
	        })) : _react2.default.createElement(_GoalRow.NewGoalRow, {
	          key: index,
	          goalTypes: allowedGoalTypes,
	          onChange: goalTypeChanged,
	          onRemove: goalRemoved
	        });
	      });
	      var classes = (0, _classnames2.default)({
	        'goals-panel': true
	      });
	
	      var toggleSelected = goals.find(function (_ref5) {
	        var _ref5$goalType = _ref5.goalType,
	            goalType = _ref5$goalType === undefined ? {} : _ref5$goalType;
	        return goalType.key === toggle;
	      });
	
	      var newButton = goals.length < goalTypes.filter(function (g) {
	        return g.key !== toggle;
	      }).length && !toggleSelected ? _react2.default.createElement(
	        'div',
	        { className: 'text-center' },
	        _react2.default.createElement(
	          'button',
	          { className: 'btn btn-secondary new', onClick: this.addGoal },
	          _react2.default.createElement(_reactIntl.FormattedMessage, _MessageDefinitions2.default.addGoal),
	          _react2.default.createElement(_reactFontawesome2.default, { name: 'plus' })
	        )
	      ) : null;
	
	      return _react2.default.createElement(
	        'div',
	        { className: classes },
	        renderedGoals,
	        newButton
	      );
	    }
	  }]);
	  return GoalPanel;
	}(_react2.default.Component), _class.propTypes = {
	  /**
	   * This key is used to lookup the goals that are currently selected.
	   */
	  goalTypesKey: _propTypes2.default.string.isRequired,
	  /**
	   * This is used to determine what to add to the end of the goalType - for example vehicleAmountToBorrow - vehicle will be goalType.key, AmountToBorrow will be the qualifier used when saving the answer
	   */
	  qualifier: _propTypes2.default.string.isRequired,
	
	  /**
	   * If provided, toggle will be treated as the "no need" answer.
	   * This option will only show if you have not answered any other values.
	   * In addition, if the toggle key is selected, it will not allow you to add any more goals.
	   */
	  toggle: _propTypes2.default.string
	}, _temp2);
	exports.default = GoalPanel;
	module.exports = exports['default'];

/***/ },

/***/ 676:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SelectedGoalRow = exports.NewGoalRow = undefined;
	
	var _extends2 = __webpack_require__(54);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MessageDefinitions = __webpack_require__(244);
	
	var _MessageDefinitions2 = _interopRequireDefault(_MessageDefinitions);
	
	var _reactIntl = __webpack_require__(10);
	
	var _reactFontawesome = __webpack_require__(31);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _reactNumberFormat = __webpack_require__(625);
	
	var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function buildOptions(optionTypes) {
	  return optionTypes.map(function (_ref) {
	    var key = _ref.key,
	        value = _ref.value;
	
	    return _react2.default.createElement(
	      'option',
	      { key: key, value: key },
	      value
	    );
	  });
	}
	
	//TODO: Pass in a component here that can be used in the return function.  Provide a default renderer otherwise.
	var NewGoalRow = function NewGoalRow(_ref2) {
	  var _ref2$goalTypes = _ref2.goalTypes,
	      goalTypes = _ref2$goalTypes === undefined ? [] : _ref2$goalTypes,
	      onChange = _ref2.onChange,
	      onRemove = _ref2.onRemove;
	
	  var goalOptions = buildOptions(goalTypes);
	
	  var typeChanged = function typeChanged(event) {
	    onChange(event.target.value);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'goal-row' },
	    _react2.default.createElement(
	      'div',
	      { className: 'goalType goal-cell form-group' },
	      _react2.default.createElement(
	        'label',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, _MessageDefinitions2.default.goalPrompt)
	      ),
	      _react2.default.createElement(
	        'select',
	        { className: 'form-control', onChange: typeChanged, value: '' },
	        _react2.default.createElement(
	          'option',
	          { value: '' },
	          'Please select'
	        ),
	        goalOptions
	      )
	    ),
	    _react2.default.createElement(
	      'button',
	      { className: 'btn btn-link remove', onClick: onRemove },
	      _react2.default.createElement(_reactFontawesome2.default, { name: 'trash-o' })
	    )
	  );
	};
	
	//TODO: Pass in a component here that can be used to custom render the component.
	//TODO: Enhanced validation
	var SelectedGoalRow = function SelectedGoalRow(_ref3) {
	  var goalType = _ref3.goalType,
	      amount = _ref3.amount,
	      _ref3$timing = _ref3.timing,
	      timing = _ref3$timing === undefined ? '' : _ref3$timing,
	      onChange = _ref3.onChange,
	      onRemove = _ref3.onRemove,
	      _ref3$qualifier = _ref3.qualifier,
	      qualifier = _ref3$qualifier === undefined ? '' : _ref3$qualifier,
	      _ref3$isToggle = _ref3.isToggle,
	      isToggle = _ref3$isToggle === undefined ? false : _ref3$isToggle;
	  var key = goalType.key,
	      value = goalType.value,
	      _goalType$timingOptio = goalType.timingOptions,
	      timingOptions = _goalType$timingOptio === undefined ? [] : _goalType$timingOptio,
	      disableAmount = goalType.disableAmount,
	      _goalType$min = goalType.min,
	      min = _goalType$min === undefined ? 0 : _goalType$min,
	      _goalType$max = goalType.max,
	      max = _goalType$max === undefined ? 0 : _goalType$max;
	
	
	  var timingCell = null;
	  if (timingOptions.length && !isToggle) {
	    var timingChanged = function timingChanged(e) {
	      onChange(e, {
	        goalType: goalType,
	        amount: amount,
	        timing: e.target.value
	      });
	    };
	
	    var timingRows = buildOptions(timingOptions, timing);
	
	    timingCell = _react2.default.createElement(
	      'div',
	      { className: 'goalTiming goal-cell form-group' },
	      _react2.default.createElement(
	        'label',
	        { htmlFor: key + 'Timing' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, _MessageDefinitions2.default.timingDefault)
	      ),
	      _react2.default.createElement(
	        'select',
	        { id: key + 'Timing', className: 'form-control', value: timing, onChange: timingChanged },
	        _react2.default.createElement(
	          'option',
	          { value: '' },
	          'Please select'
	        ),
	        timingRows
	      ),
	      timing ? null : _react2.default.createElement(
	        'div',
	        { className: 'invalid-feedback' },
	        _react2.default.createElement(_reactIntl.FormattedMessage, _MessageDefinitions2.default.validationRequired)
	      )
	    );
	  }
	
	  var amountCell = null;
	  if (!disableAmount && !isToggle) {
	    var amountChanged = function amountChanged(e, _ref4) {
	      var floatValue = _ref4.floatValue;
	
	      onChange(e, {
	        goalType: goalType,
	        amount: floatValue,
	        timing: timing
	      });
	    };
	
	    var validateAmount = function validateAmount(amount) {
	      var message = false;
	      var formattedValues = {
	        min: _react2.default.createElement(_reactIntl.FormattedNumber, { value: min, style: 'currency', currency: 'USD', maximumFractionDigits: 2, minimumFractionDigits: 2 }),
	        max: _react2.default.createElement(_reactIntl.FormattedNumber, { value: max, style: 'currency', currency: 'USD', maximumFractionDigits: 2, minimumFractionDigits: 2 })
	      };
	      if (!amount) {
	        message = _react2.default.createElement(_reactIntl.FormattedMessage, _MessageDefinitions2.default.validationRequired);
	      } else if (max && (amount < min || amount > max)) {
	        message = _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, _MessageDefinitions2.default.validationBetween, { values: formattedValues }));
	      } else if (amount < min) {
	        message = _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, _MessageDefinitions2.default.validationMinimum, { values: formattedValues }));
	      }
	      return message ? _react2.default.createElement(
	        'div',
	        { className: 'invalid-feedback' },
	        message
	      ) : null;
	    };
	
	    amountCell = _react2.default.createElement(
	      'div',
	      { className: 'goalAmount goal-cell form-group' },
	      _react2.default.createElement(
	        'label',
	        { htmlFor: '' + key + qualifier },
	        _react2.default.createElement(_reactIntl.FormattedMessage, _MessageDefinitions2.default.amountDefault)
	      ),
	      _react2.default.createElement(_reactNumberFormat2.default, { id: '' + key + qualifier,
	        className: 'answer form-control',
	        value: amount,
	        thousandSeparator: true, prefix: '$',
	        decimalPrecision: 0,
	        onChange: amountChanged }),
	      validateAmount(amount)
	    );
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'goal-row' },
	    _react2.default.createElement(
	      'div',
	      { className: 'goalType goal-cell form-group' },
	      _react2.default.createElement(
	        'label',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, _MessageDefinitions2.default.goalPrompt)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'form-control form-control-plaintext' },
	        value
	      )
	    ),
	    amountCell,
	    timingCell,
	    _react2.default.createElement(
	      'button',
	      { className: 'btn btn-link remove', onClick: onRemove },
	      _react2.default.createElement(_reactFontawesome2.default, { name: 'trash-o' })
	    )
	  );
	};
	
	exports.NewGoalRow = NewGoalRow;
	exports.SelectedGoalRow = SelectedGoalRow;

/***/ }

});


/** WEBPACK FOOTER **
 ** goal-builder.min.js
 **/